/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { PluginKey as e } from "@progress/kendo-editor-common";
const r = new e("editor-props");
export {
  r as editorPropsKey
};
